import { IBaseCompany } from '../../Auth/types/company.types';
import { IDocument } from '../../Document/types/document.types';
import { IPartnerRequest } from '../../Partner/types/partner.types';

export interface IQuestionnaireTemplate {
  id: string;
  title: string;
  createdTimestamp: Date;
}

export enum EQuestionnaireRiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  PENDING = 'PENDING',
}

export type TQuestionnaireRiskLevel = `${EQuestionnaireRiskLevel}`;
export interface IBaseQuestionnaire {
  id: string;
  title: string;
  templateId: string;
  year: number;
  externalId: string;
  createdBy: IBaseCompany;
}

export interface IQuestionnaire extends IBaseQuestionnaire {
  sections: IQuestionnaireCompanySection[];
  requestsSent: IPartnerRequest[];
  requestReceived: IPartnerRequest;
}

export interface IQuestionnaireCompanyResponse {
  id: string;
  questionnaireId: string;
  riskLevel?: TQuestionnaireRiskLevel;
  sections: IQuestionnaireCompanySection[];
  answerSummary: IAnswerSummary;
  modifiedTimestamp: Date;
  partnerRequest?: IPartnerRequest;
}

export interface IAnswerSummary {
  lowRiskCount: number;
  mediumRiskCount: number;
  highRiskCount: number;
}

export interface IQuestionnaireCompanySection {
  id: string;
  title: string;
  description?: string;
  questions: IQuestionnaireQuestion[];
}

export enum EQuestionType {
  NO_ANSWER = 'NO_ANSWER',
  SHORT_FREE_TEXT = 'SHORT_FREE_TEXT',
  LONG_FREE_TEXT = 'LONG_FREE_TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  DOCUMENTS = 'DOCUMENTS',
  SINGLE_SELECT_DROP_DOWN = 'SINGLE_SELECT_DROP_DOWN',
  MULTI_SELECT_DROP_DOWN = 'MULTI_SELECT_DROP_DOWN',
}

export type TQuestionType = `${EQuestionType}`;

export interface IQuestionnaireQuestion {
  id: string;
  questionText: string;
  description?: string;
  answerText?: string;
  questionType: TQuestionType;
  selectedOptionIds?: string[];
  isRequired?: boolean;
  commentText?: string;
  riskLevel?: TQuestionnaireRiskLevel;
  options?: IQuestionnaireQuestionOption[];
  proofDocuments?: IDocument[];
}

export interface IQuestionnaireQuestionOption {
  id: string;
  text: string;
  isCommentRequired?: boolean;
}

export interface IQuestionnaireFormValues {
  sections: {
    [sectionId: string]: {
      questions: {
        [questionId: string]: {
          answerText?: string;
          selectedOptionId?: string;
          selectedOptionIds?: string[];
          documents?: { id: string; title?: string; inUploadContext?: boolean }[];
          commentText?: string;
        };
      };
    };
  };
}
